import styled from 'styled-components';

const Image = styled.img`
  display: inline-block;
  margin-bottom: 10px;
  height: 100%;
  width: 100%;
  border-radius: 4px;
`;

export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.tsx